// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'component-library';
import Article from './Article.js';
import { getArticlesForSport } from '../../../../redux/actions/articles';
import './Articles.css';

// header

type Props = {
    sport: string,
    articles: { [key: string]: any },
    getArticlesForSport: Function
};

class Articles extends Component<Props> {
    componentDidMount() {
        if (this.props.sport !== null) {
            this.props.getArticlesForSport(this.props.sport);
        }
    }

    render() {
        const articlesHeader = (
            <div className={'modal-subheader'} style={{ paddingLeft: '0' }}>
                Recent {this.props.sport.toUpperCase()} Articles
            </div>
        );
        let articlesDetail = <Spinner />;
        if (this.props.articles.isLoading === false) {
            if (this.props.articles.results) {
                const articlesArray = this.props.articles.results;
                const articlesLen = articlesArray.length;
                if (articlesLen > 0) {
                    articlesDetail = (
                        <div className={'article-container styled-scrollbar'}>
                            {articlesArray.map(function(n) {
                                return <Article key={n.id} articleItem={n} />;
                            })}
                        </div>
                    );
                } else {
                    articlesDetail = <div className={'article-container'}>No recent news for this sport.</div>;
                }
            }
        }
        return (
            <React.Fragment>
                {articlesHeader}
                {articlesDetail}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        articles: state.articles
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getArticlesForSport: sportName => dispatch(getArticlesForSport(sportName))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Articles);



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/Articles/Articles.js